export const cardPresentationLimits = {
  completed: 4,
  rejected: 4,
};

export type CardPresentationType = keyof typeof cardPresentationLimits;

const getCardPresentationLimit = (cardType: CardPresentationType) => cardPresentationLimits[cardType];

const shouldCardBeShown = (cardPresentedCount: number, cardType: CardPresentationType) => {
  return cardPresentedCount < getCardPresentationLimit(cardType);
};

export const shouldCompletedCardBeShown = (cardPresentedCount: number) => {
  return shouldCardBeShown(cardPresentedCount, 'completed');
};

export const shouldRejectedCardBeShown = (cardPresentedCount: number) => {
  return shouldCardBeShown(cardPresentedCount, 'rejected');
};

export const getInitialCardCount = (cardType: CardPresentationType) => getCardPresentationLimit(cardType);
